export default function usePageScroll() {
    function scrollToTop(): void {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    function scrollToElement(elementId: string): void {
        document
            .getElementById(elementId)
            ?.scrollIntoView({ behavior: 'smooth' })
    }

    return {
        scrollToTop,
        scrollToElement,
    }
}
